import { render, staticRenderFns } from "./ChipCloseIcon.vue?vue&type=template&id=a2d81cc8&"
import script from "./ChipCloseIcon.vue?vue&type=script&lang=js&"
export * from "./ChipCloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports